import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibSlider',
  props: {
    value: {
      type: Number
    },
    max: {
      type: Number,
      default: 10
    },
    labelLeft: {
      type: String
    },
    labelRight: {
      type: String
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    initState: function initState() {
      return typeof this.value === 'undefined';
    },
    style: function style() {
      return {
        color: this.theme.primaryColor
      };
    }
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('input', Math.round(value));
    }
  }
};